<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">
    <g transform="translate(-1112 -920)">
      <rect class="a" width="18" height="11" rx="2" transform="translate(1113 930)"/>
      <path class="a" d="M7,11V7A5,5,0,0,1,17,7v4" transform="translate(1110 919)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LockClosedIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
